import { getBaseURL, get, post, deletes } from "./request";

const HttpManager = {
  submitContactMessage: ({name, email, phone, content}) => post(`customer/add`, {name, email, phone, content}),

  // item可以是导航ID（数字）或特殊标识（字符串），device可选pc/mobile
  getFontStyle: ({item, type, device = 'pc'}) => get(`font?item=${item}&type=${type}&device=${device}`),

  getNavigation: () => get(`nav`),

  getNavigationConfig: () => get(`nav/list?isVisible=1`),

  getCompanyHome: ({item}) => get(`companyHome?item=${item}`),

  getNewsRecommend: () => get(`production/recommend?item=${'xwzx'}&recommend=${'1'}`),

  getIndustryBackground: () => get(`industryBackground`),
  getCompanyInfo: () => get(`companyInfo`),
  getAboutInfo: ({item}) => get(`infoManage?item=${item}`),
  // 获取图片信息
  attachImageUrl: (url) => url ? `${getBaseURL()}/${url}` : "https://cube.elemecdn.com/e/fd/0fc7d20532fdaf769a25683617711png.png",

    // =======================> 推荐 API 完成
  // 获取古城推荐（全量，不含 content 大字段）
  getAllProduction: (item) => get(`production?item=${item}`),
  // 分页获取推荐列表（不含 content 大字段，服务端分页）
  getProductionPage: (item: string, page: number, pageSize: number) =>
    get(`production/page?item=${item}&page=${page}&pageSize=${pageSize}`),
  // 根据id获取古城推荐
  getAllProductionByID: (id) => get(`production/detail?id=${id}`),
  // 获取古城推荐类型类型
  getProductionOftype: (type) => get(`production/type/detail?type=${type}`),

  // 获取所有的海报
  getBannerList: () => get("banner"),

  // =======================> 首页模块 API
  // 获取首页模块列表
  getHomepageModules: () => get("homepage/modules")
};



export { HttpManager };
